/*
 * @Author: dengfang 36882215@qq.com
 * @Date: 2024-02-05 16:26:31
 * @LastEditors: dengfang 36882215@qq.com
 * @LastEditTime: 2024-02-05 16:54:29
 * @FilePath: /pophr-ms/src/util/expire-dialog.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { MessageBox } from 'element-ui'
import { oneDayLong } from 'util/util'
import Cookies from 'js-cookie'

/**
 * @param {string} time
 * @returns 当剩余 day 天过期，弹框
 */
export default ({ expire_time, audit_status }, $t) => {
  // 剩余 多少 天
  const day = +Math.ceil((new Date(expire_time).getTime() - Date.now()) / oneDayLong) + 1
  // 未认证 且 小于等于7天 并且 在 7天内没有弹过框
  if (audit_status === '2' && day <= 7 && !Cookies.get('isExpireDialog')) {
    MessageBox({
      title: $t('prompt'),
      message: $t('expire_dialog.1', { day }),
      showClose: false,
      closeOnClickModal: false,
      confirmButtonText: $t('expire_dialog.2'),
      showCancelButton: true,
      cancelButtonText: $t('66')
    })
      .then(_ => window.open('https://www.pophr.com/contact-us'))
      .catch(_ => false)
      .finally(_ =>
        Cookies.set('isExpireDialog', true, {
          expires: process.env.NODE_ENV === 'production' ? 7 : new Date(Date.now() + 30 * 1000)
        })
      )
  }
}
